"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigMap = void 0;
/**
 * BigMap implementation allows callers to handle more than 2^24 items in memory.
 * - This is not directly compatible with existing JS Map, but fulfills most of the API.
 * - Why? it should not be an encouraged pattern to operate on this size of data in memory
 * - If this is being used, it must be intentional
 */
class BigMap {
    // Internal limit is used to determine when to create a new internal map
    individualMapSizelimit = 10_000_000;
    // Internal data storage with chunked maps, not to be exposed directly
    // Always initialized with one empty map
    maps = [new Map()];
    /**
     * BigMap implementation allows callers to handle more than 2^24 items in memory.
     * - This is not directly compatible with existing JS Map, but fulfills most of the API.
     * - Why? it should not be an encouraged pattern to operate on this size of data in memory
     * - If this is being used, it must be intentional
     *
     * BigMap constructor accepts entries and an internal map size limit override
     * @param entries Initial set of data to populate
     * @param individualMapSizelimit Internal map size override, but always capped at 10 million
     *
     */
    constructor(entries = [], individualMapSizelimit = 10_000_000) {
        this.individualMapSizelimit = individualMapSizelimit;
        for (const [key, value] of entries) {
            this.set(key, value);
        }
    }
    // Mutable attribute, implement as getter
    get size() {
        // This should be O(1) operation as long as individual maps provide the same access pattern
        return this.maps.reduce((sum, map) => sum + map.size, 0);
    }
    // Operations
    get(key) {
        for (const map of this.maps) {
            if (map.has(key)) {
                return map.get(key);
            }
        }
        // Key not found in any map, return default
        return undefined;
    }
    // No chaining enabled
    set(key, value) {
        // *** 3 processing scenarios, in order of priority ***
        // 1) Find map that already contains key
        const existingMap = this.maps.find((map) => map.has(key));
        if (existingMap) {
            existingMap.set(key, value);
            return;
        }
        // 2) Add to map with capacity
        const mapWithCapacity = this.maps.find((map) => map.size < this.individualMapSizelimit);
        if (mapWithCapacity) {
            mapWithCapacity.set(key, value);
            return;
        }
        // 3) No map contains the key, or has capacity -> add a new map
        this.maps.push(new Map([[key, value]]));
    }
    has(key) {
        return this.maps.some((map) => map.has(key));
    }
    // Iterators - supporting only the common entries() access pattern at this time
    // Additional: keys()/values() can be added with similar yield statements
    entries() {
        function* generator(maps) {
            for (const map of maps) {
                yield* map.entries();
            }
        }
        return generator(this.maps);
    }
}
exports.BigMap = BigMap;
//# sourceMappingURL=bigMap.js.map